<template>
  <pt-goods-group class="pt-goods-group__page"></pt-goods-group>
</template>

<script>
import PtGoodsGroup from 'cps/mall-manage/pt-goods-group/withData'
export default {
  name: 'pt-goods-group__view',
  components: {
    'pt-goods-group': PtGoodsGroup
  }
}
</script>
